import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '../contexts/AuthContext';
import { WorkspaceDashboard } from '../shared/components/WorkspaceDashboard';
import { JobStatus } from '../shared/components/JobStatus';
import { UserHistory } from '../shared/components/UserHistory';
import { Header } from '../shared/components/Header';
import { Footer } from '../shared/components/Footer';
import LoginModal from '../components/Auth/LoginModal';
import ProtectedRoute from '../components/Auth/ProtectedRoute';
import './App.css';

// Layout component
const Layout = ({ children }) => (
  <div className="min-h-screen bg-gradient-to-b from-orange-50 to-gray-50">
    <Toaster
      position="top-right"
      toastOptions={{
        // Default options for all toasts
        duration: 5000, // 5 seconds (was 4 seconds default)
        style: {
          background: '#fff',
          color: '#1f2937',
          padding: '16px 20px',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: '500',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          maxWidth: '500px',
        },
        // Success toast styling
        success: {
          duration: 5000,
          iconTheme: {
            primary: '#10b981',
            secondary: '#fff',
          },
          style: {
            background: '#ecfdf5',
            color: '#065f46',
            border: '1px solid #6ee7b7',
          },
        },
        // Error toast styling
        error: {
          duration: 6000, // Errors stay longer
          iconTheme: {
            primary: '#ef4444',
            secondary: '#fff',
          },
          style: {
            background: '#fef2f2',
            color: '#991b1b',
            border: '1px solid #fca5a5',
          },
        },
        // Loading toast styling
        loading: {
          iconTheme: {
            primary: '#f59e0b',
            secondary: '#fff',
          },
        },
      }}
    />
    <LoginModal />
    <Header />
    <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      {children}
    </main>
    <Footer />
  </div>
);

// Create router with future flags
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout><WorkspaceDashboard /></Layout>
  },
  {
    path: "/job/:jobId",
    element: <Layout><JobStatus /></Layout>
  },
  {
    path: "/history",
    element: <Layout><ProtectedRoute><UserHistory /></ProtectedRoute></Layout>
  }
], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
});

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
